import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Type } from '@angular/core';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from './_services/script-loader.service';
import { ThemeRoutingModule } from './theme/theme-routing.module';
import { AuthModule } from './auth/auth.module';
// Integrations
import * as Papi from '@app/papi';
import * as Leaflet from './leaflet';

// Vendor
import { ToastrModule } from 'ngx-toastr';
import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

// import { LeafletModule } from '@asymmetrik/ngx-leaflet';
// import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';

// Vendor Components
import { BlockUITemplateComponent } from './vendor/block-ui/block-ui-template.component';

import { EnvironmentService } from 'environments/environment-service';
import { PulseModule } from './pulse/pulse.module';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletDrawModule } from '@bluehalo/ngx-leaflet-draw';
declare module "@angular/core" {
    interface ModuleWithProviders<T = any> {
      ngModule: Type<T>;
    }
  }  /// It will fix the Import module issue getting the error from the papi-client and color-module
@NgModule({
    declarations: [
        ThemeComponent,
        AppComponent,
        // Vendor
        BlockUITemplateComponent
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ThemeRoutingModule,
        AuthModule,
        // Integrations
        Papi.PapiModule,
        Leaflet.LeafletModule,
        // Vendor
        ToastrModule.forRoot({
            progressBar: true,
            preventDuplicates: true
        }),
        BlockUIModule.forRoot({
            template: BlockUITemplateComponent
        }),
        SweetAlert2Module,
        LeafletModule,
        LeafletDrawModule,
        // RestModule,
        PulseModule
    ],
    providers: [
        ScriptLoaderService,
        EnvironmentService
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule { }